import { useJudgeApprovalRequestStore } from 'src/hooks/stores'

export const useJudgeApprovalRequest = () => {
  const { judgeApprovalRequestStoreValue, setJudgeApprovalRequestStoreValue } =
    useJudgeApprovalRequestStore()

  const showJudgeApprovalRequest = () => {
    setJudgeApprovalRequestStoreValue({
      isShow: true,
    })
  }

  const hideJudgeApprovalRequest = () => {
    setJudgeApprovalRequestStoreValue({
      isShow: false,
    })
  }

  return {
    isShow: judgeApprovalRequestStoreValue.isShow,
    showJudgeApprovalRequest,
    hideJudgeApprovalRequest,
  }
}
